import {Key, ReactNode} from 'react';

import {SettingsHomeDestinationsEnum} from '../../../../settings/home/settingsHomeTypes';
import {AppStore} from '../../../../store/appStore';

/*
 * Types.
 */

export interface OnboardingTaskGroup {
  key: Key;
  title: ReactNode;
  tasks: ReadonlyArray<OnboardingTask>;
}

export interface OnboardingTask {
  key: Key;
  title: ReactNode;
  description: ReactNode;
  details: ReactNode;
  isTaskComplete: boolean | undefined;
  startTask(context: OnboardingTaskStartContext): Promise<void> | void;
  computeTrackingEventData(): OnboardingTaskTrackingEventData;
}

export interface OnboardingTaskStartContext {
  dispatch: AppStore['dispatch'];
  openAdminWizard(): void;
  openSettingsHomeShortcut(destination: SettingsHomeDestinationsEnum): void;
}

export interface OnboardingTaskTrackingEventData {
  click_object: string;
  user_track: string;
}

/*
 * Helpers.
 */

export function computeOnboardingProgress(taskGroups: ReadonlyArray<OnboardingTaskGroup>) {
  const allTasks = taskGroups.flatMap((group) => group.tasks);
  const numCompletedTasks = allTasks.filter((task) => task.isTaskComplete).length;
  const numTotalTasks = allTasks.length;

  return {numCompletedTasks, numTotalTasks};
}
